import React, { useState } from 'react'
import clsx from 'clsx'
import SelectModal from 'components/shared/modals/SelectModal/SelectModalAssets';
import { ReactComponent as IconArrow } from 'images/arrow-down-w.svg';
import { ReactComponent as IconPlus } from 'images/plus-circle.svg';
import Button from 'components/shared/Button';
import Input from 'components/shared/Input';
import styles from './SelectWithModal.module.scss';

type SelectWithModalAssetsProps = {
  title: string,
  options: any[],
  btnText?: string,
  multiple?: boolean,
  showIcons?: boolean,
  isSearchable?: boolean,
  className?: string,
  placeholder?: string,
  onSelect: (v: any) => void,
  value?: any,
  ItemComponent?: React.FC<{ data: any }>,
  notFoundMessage?: React.ReactNode,
  notFoundButton?: any,
  noBtn?: boolean,
  IconComponent?: React.FC<{ data: any }>,
  disabled?: boolean,
  onBeforeChange?: () => boolean,
  maxLength?: number
  search?: string
  setSearch?: any
  searchFunc?: (v: string) => (v: any) => boolean,
  isLoading?: boolean,
  hasNext?: boolean,
  onNextPage?: (page: number) => void,
}

function Value({ data, remove }: {
  data: any, remove: (v: string | number) => void,
}) {
  return (
    <div
      className={styles.value}
      onClick={(e?: React.FormEvent<HTMLDivElement>) => e?.stopPropagation()}
    >
      {data?.icon ? <img src={data?.icon} alt={data?.name} /> : null}
      {data?.name}
      <Button
        iconBtn
        onClick={() => remove(data?.id)}
      >
        <IconPlus />
      </Button>
    </div>
  )
}

function SelectWithModalAssets({
  title,
  className,
  options,
  btnText = 'Select',
  multiple,
  showIcons,
  isSearchable,
  onSelect,
  value,
  ItemComponent,
  IconComponent,
  notFoundMessage,
  notFoundButton,
  noBtn,
  disabled,
  onBeforeChange = () => true,
  placeholder,
  maxLength,
  search,
  setSearch,
  searchFunc,
  isLoading,
  hasNext,
  onNextPage,
}: SelectWithModalAssetsProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const remove = (id: string | number) => {
    onSelect(value.filter((v) => (v.id !== id)))
  }

  return (
    <>
      {(multiple && value?.length) ? (
        <div
          className={clsx(styles.inputMultiple, className)}
          onClick={() => setIsOpen(true)}
        >
          {value.map((v: any) => (
            <Value key={v.id} data={v} remove={remove} />
          ))}
        </div>
      ) : (
        <Input
          icon={IconComponent ? (<IconComponent data={value} />) : null}
          className={className}
          onClick={() => { if (!disabled && onBeforeChange()) setIsOpen(true) }}
          value={value?.name}
          suffix={<IconArrow className={styles.dropdownIndicator} />}
          disabled={disabled}
          placeholder={placeholder}
        />
      )}
      {isOpen ? (
        <SelectModal
          title={title}
          options={options}
          btnText={btnText}
          isOpen={isOpen}
          isSearchable={isSearchable}
          multiple={multiple}
          showIcons={showIcons}
          onClose={() => setIsOpen(false)}
          onSelect={(v: any) => {
            onSelect(v)
            setIsOpen(false)
          }}
          value={value}
          search={search}
          setSearch={setSearch}
          searchFunc={searchFunc}
          ItemComponent={ItemComponent}
          notFoundMessage={notFoundMessage}
          notFoundButton={notFoundButton}
          noBtn={noBtn}
          maxLength={maxLength}
          isLoading={isLoading}
          hasNext={hasNext}
          onNextPage={onNextPage}
        />
      ) : null}
    </>
  )
}

export default SelectWithModalAssets
